exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".orgDropdown .btn-group>button.btn.btn-link:first-child{padding-left:0}.orgDropdown .placeholder .glyphicon{font-size:.8em;margin-left:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/org_dropdown.scss
// module id = 1325
// module chunks = 0